import React from 'react';
import { Link } from "gatsby"
import { navigate } from '@reach/router';
import Img from "gatsby-image"
import { Container } from './footer.css';

const onClick = () => {
  navigate('#some-link');
  // OR
  navigate('?foo=bar');
}

const Footer = ({ post }) => (
  <Container>
    <footer id="footer" className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-4"></div>
            <div className="col-lg-4 col-md-4">
              <div className="widget widget-social">
                <div className="horizontal">
                  <ul className="social">
                    <li><a href="http://twitter.com/ruddhani" target="_blank" rel="noreferrer"><i className="fa fa-twitter">&nbsp;</i></a></li>
                    <li><a href="http://instagram.com/ruddhani" target="_blank" rel="noreferrer"><i className="fa fa-instagram">&nbsp;</i></a></li>
                    <li><a href="http://pinterest.com/ruddhani" target="_blank" rel="noreferrer"><i className="fa fa-pinterest">&nbsp;</i></a></li>
                    <li><a href="http://aniruddha-blog.netlify.com/" target="_blank" rel="noreferrer"><i className="fa fa-heart">&nbsp;</i></a></li>
                    <li><a className="icon icon-github" href="https://github.com/ruddhani/">&nbsp;</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4"></div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="copy-right"><Link onClick>Copyright ©2020.</Link></div>
      </div>
    </footer>
  </Container>
);

export default Footer;